import { call, put, takeLatest } from 'redux-saga/effects'

import {
  postFertilizer,
  putFertilizer,
  deleteFertilizer,
  postFertilizerManufacturer,
  putFertilizerManufacturer
} from '@galo-monitor/services/apis/galoMonitorApi/resources/fertilizer'

import { FertilizerActions, FertilizerTypes } from './duckFertilizer'

function* saveFertilizer({ fertilizer, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(fertilizer.id ? putFertilizer : postFertilizer, fertilizer)
    yield call(onSuccess)
  } catch (err) {
    yield put(FertilizerActions.fertilizerError(err.message))
    yield call(onError, err)
  }
}

function* removeFertilizer({ fertilizer, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(deleteFertilizer, fertilizer)
    yield call(onSuccess)
  } catch (err) {
    yield put(FertilizerActions.fertilizerError(err.message))
    yield call(onError, err)
  }
}

function* saveFertilizerManufacturer({ manufacturer, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(manufacturer.id ? putFertilizerManufacturer : postFertilizerManufacturer, manufacturer)
    yield call(onSuccess)
  } catch (err) {
    yield put(FertilizerActions.fertilizerError(err.message))
    yield call(onError, err)
  }
}

export default [
  takeLatest(FertilizerTypes.SAVE_FERTILIZER, saveFertilizer),
  takeLatest(FertilizerTypes.REMOVE_FERTILIZER, removeFertilizer),
  takeLatest(FertilizerTypes.SAVE_FERTILIZER_MANUFACTURER, saveFertilizerManufacturer)
]
